import styles from "./styles.module.css"
import AdditionalInformationSelect from "./vehicle-info-selects/AdditionalInformationSelect"
import MakeInformationSelect from "./vehicle-info-selects/MakeInformationSelect"
import ModelInformationSelect from "./vehicle-info-selects/ModelInformationSelect"
import YearInformationSelect from "./vehicle-info-selects/YearInformationSelect"
import { ICustomerVehicle } from "../../../../../../../../app/entities/CustomerVehicle"
import { IBrand } from "../../../../../../../../app/entities/Brand"

export interface IVehicleInformationSelectProps {
	customerVehicle: Partial<ICustomerVehicle>
	label: string
	onChange: Function
}

interface ICustomerVehicleFormProps {
	customerVehicle: Partial<ICustomerVehicle>
	setCustomerVehicle: Function
}

export default function VehicleInformationForm({
	customerVehicle,
	setCustomerVehicle,
}: ICustomerVehicleFormProps) {

	const onVehicleInformationChange = (update: Record<string, any>) => {
		const key = Object.keys(update)[0]
	
		if (key === 'brand') {
			setCustomerVehicle((prevState: any) =>({
				...prevState,
				...update,
				year: '',
				model: '',
				variant: '',
			}))
		} else if (key === 'year') {
			setCustomerVehicle((prevState: any) => ({
				...prevState,
				...update,
				model: '',
				variant: '',
			}))
		} else if (key === 'model') {
			setCustomerVehicle((prevState: any) => ({
				...prevState,
				...update,
				variant: '',
			}))
		} else {
			setCustomerVehicle((prevState: any) => ({
				...prevState,
				...update,
			}))
		}
	}

	return (
		<div className={styles.contactFormContainer}>
			<div className={`${styles.contactTitle} font--bold`}>Vehicle Information</div>
			<MakeInformationSelect
				label="Make"
				customerVehicle={customerVehicle}
				onChange={(brand: Partial<IBrand>) => onVehicleInformationChange({brand})}
			/>
			{customerVehicle.brand?.objectId && (
				<YearInformationSelect
					label="Year"
					customerVehicle={customerVehicle}
					onChange={(year: string) => setCustomerVehicle({...customerVehicle, year})}
				/>
			)}
			{customerVehicle.year && (
				<ModelInformationSelect
					label="Model"
					customerVehicle={customerVehicle}
					onChange={(model: string) => setCustomerVehicle({...customerVehicle, model})}
				/>
			)}
			{customerVehicle.model && (
				<AdditionalInformationSelect
					label="Additional Information"
					customerVehicle={customerVehicle}
					onChange={(variant: string) => setCustomerVehicle({...customerVehicle, variant})}
				/>
			)}
		</div>
	)
}
